

import { Button, Card, Skeleton, DatePicker, Spin } from "antd";
import React, { useEffect, useState } from "react";

import ReactApexChart from "react-apexcharts";
// import dayjs from "dayjs";
import { TimePicker } from "antd";

import {
  filterDataByTimeRange,
  generatedISOFormatDateString,
  groupDataByInterval,
  setUTCDate,
} from "../../../../../../Utils/DateConverstion";

import CustomDrawer from "../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../Elements/CustomSelect";
import TreeSelectCustomWithSelectAll from "../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll"
import ExportToExel from "../RawData/RawDataGrid/Export";
import { useSelector } from "react-redux";
import TreeSelectCustom from "../../LiveModule/LiveTrends/LineChart/TreeSelectCustom";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";

// import moment from "moment";

const { RangePicker } = TimePicker;

const ComparitiveReport = () => {
  const { loading, makeRequest } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState(null);
const [converterGroupId, setConverterGroupId] = useState();
const [report, setReport] = useState(null);
const [selectedMeterIds, setSelectedMeterIds] = useState([]);
const [selectedValues, setSelectedValues] = useState([]);
const [fromDateObj, setFromDateObj] = useState(null);
const [fromDateString, setFromDateString] = useState(null);
const [toDateObj, setToDateObj] = useState(null);
const [toDateString, setToDateString] = useState(null);
const [skip, setSkip] = useState(true);
const [open, setOpen] = useState(false);

const [meters, setMeters] =useState([])
const [excelReport, setExcelReport] = useState([])
const [isLoading, setIsLoading] = useState(true);

const [aggregationTime, setAggregationtime] = useState(null);

const [aggeregationResData, setaggeregationResData] = useState([]);
const [sectionError, setSectionError] = useState();
const [converterError, setConverterError] = useState();
const [meterError, setMeterError] = useState();
const [paraError, setParaError] = useState();
const [fromDateError, setFromDateError] = useState();
const [toDateError, setToDateError] = useState();
const [aggregationError, setAggregationError] = useState();
const [flowSectionResData, setflowSectionResData] = useState([]);
const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]);
const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] = useState([]);
const [data, setData] = useState([]);

const mode = useSelector((state) => state.darkMode);

const { isdarkMode } = mode;


const showDrawer = () => {
  setOpen(true);
};
const onClose = () => {
  setOpen(false);
};


const [chartData, setChartData] = useState({
  series: [],
  options: {
    chart: {
      id: "Comparative-report",
      height: 350,
      type: "line",
      zoom: {
        type: "x",
        enabled: true,
        // autoScaleYaxis: true,
      },
      toolbar: {
        autoSelected: "zoom",
      },
    },
    legend: {
      show: true,
      showForSingleSeries: true,
      showForNullSeries: true,
      showForZeroSeries: true,
      position: 'bottom',
      horizontalAlign: 'center', 
      floating: false,
      fontSize: '14px',
      fontFamily: 'Helvetica, Arial',
      fontWeight: 400,
      formatter: undefined,
      inverseOrder: false,
      width: undefined,
      height: undefined,
      tooltipHoverFormatter: undefined,
      customLegendItems: [],
      offsetX: 0,
      offsetY: 0,
      labels: {
          colors: undefined,
          useSeriesColors: false
      },
      markers: {
          width: 12,
          height: 12,
          strokeWidth: 0,
          strokeColor: '#fff',
          fillColors: undefined,
          radius: 12,
          customHTML: undefined,
          onClick: undefined,
          offsetX: 0,
          offsetY: 0
      },
      itemMargin: {
          horizontal: 5,
          vertical: 10
      },
      onItemClick: {
          toggleDataSeries: true
      },
      onItemHover: {
          highlightDataSeries: false
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    markers: {
      size: 5,
      strokeOpacity: 0.3,
      hover: {
        size: undefined,
        sizeOffset: 3,
      },
    },
    title: {
      // display: true,
      text: "Comparative Chart",
      // color:  'red',

      style: {
 color: isdarkMode ? "#FFFFFF" : "#000000",
            // className={`p-4 rounded-md dark ${isdarkMode ? "darkmode" : "whitemode"}`
         fontSize: "18px", 
         fontWeight: "bold" },
      
    },
    xaxis: {
      categories: [],
      labels: { 
        style: { 
          color: "red",
        }
      },
      title: { 
        text: "Date", 
        style: {
          color: isdarkMode ? "#FFFFFF" : "#000000",
        }
      }
    },
    yaxis: {
      title: {
        text: "Value",
      },
    },
    // tooltip: {
    //   y: [
    //     {
    //       title: {
    //         formatter: function (val) {
    //           return val + " (mins)";
    //         },
    //       },
    //     },
    //     {
    //       title: {
    //         formatter: function (val) {
    //           return val + " per session";
    //         },
    //       },
    //     },
    //     {
    //       title: {
    //         formatter: function (val) {
    //           return val + "Kg";
    //         },
    //       },
    //     },
    //   ],
    // },
    tooltip: {
      x: {
        show: true,
        format: "dd-MMM",
        formatter: undefined,
      },
      y: {
        title: {
          formatter: (
            seriesName,
            { series, seriesIndex, dataPointIndex, w }
          ) => {
            const isFlowRate = seriesName.includes("flowRate");
            const kgLabel = isFlowRate ? " Kg/hr" : "Kg";

            // Assuming opts.value contains the actual y-axis value
            return seriesName + kgLabel;
          },
        },
      },
    },
  },
});


useEffect(() => {
  // After 1 second, set skipValue to false
  const timeoutId = setTimeout(() => { 
    setSkip(false);
  }, 3000);

  // Clear the timeout if the component unmounts or skipValue is set to false
  return () => clearTimeout(timeoutId);
}, []);

useEffect(() => {
  makeRequest({
    type: APIConstants.GET,
    // GetFlowSteamGropeMeterDetails?GroupID=81
    url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`
  }).then((res) => {
    console.log(res)
    setflowSectionResData(res);
  });


  makeRequest({
    type: APIConstants.GET,
    // GetFlowSteamGropeMeterDetails?GroupID=81
    url: `${APIConstants.GET_FLOW_CONVERTER_DETAILS}`
  }).then((res) => {
    console.log(res)
    setgetFlowConverterResData(res);
  });


  makeRequest({
    type: APIConstants.GET,
    // GetFlowSteamGropeMeterDetails?GroupID=81
    url: `${APIConstants.GET_STEAM_FLOW_GROUP_DETAILS}`
  }).then((res) => {
    console.log(res)
    setflowGroupDetailsResData(res);
  });


  makeRequest({
    type: APIConstants.GET,
  
    url: `${APIConstants.GET_STEAM_AGGREGATION_PERIOD}`
  }).then((res) => {
    console.log(res)
    setaggeregationResData(res);
  });

}, [])



useEffect(() => {

  if(converterGroupId) {
    makeRequest({
      type: APIConstants.GET,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.GET_FLOW_NS_CONVERTER_DETAILS}?ConverterID=${converterGroupId}`
    }).then((res) => {
      console.log(res)
      setnsGetFlowConverterResData(res);
    });

  }


  makeRequest({
    type: APIConstants.GET,
    // GetFlowSteamGropeMeterDetails?GroupID=81
    url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${converterGroupId}`
  }).then((res) => {
    console.log(res)
    setgetFlowSteamGroupMeterResData(res);
  });
}, [converterGroupId])



const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
const getFlowConverterList =
  (getFlowConverterResData && getFlowConverterResData) || [];
const flowGroupDetailsList =
  (flowGroupDetailsResData && flowGroupDetailsResData) || [];
  const nsGetFlowConverterList =
  (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
const getFlowSteamGroupMeterList =
  (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];
  const aggeregationList = (aggeregationResData && aggeregationResData) || [];

// console.log(nsGetFlowConverterList)
const handleChangeAggregation = (value) => {
setAggregationtime(value);
if (value) {
  setAggregationError("");
}
};


const handleChangeSection = (changedValues) => {
  setSectionId(changedValues);
  setSelectedMeterIds();
  if (changedValues) {
    setSectionError("");
  }
};

const handleChangeConverterGroup = (changedValues) => {
  setConverterGroupId(changedValues);
  setSelectedMeterIds();
  if (changedValues) {
    setConverterError("");
  }
};

const handleMeterChange = (selectedValues) => {
  setSelectedMeterIds(selectedValues);
  if (selectedValues) {
    setMeterError("");
  }
};

const onChangeFromDate = (date, dateString) => {
  setFromDateString(dateString);
  setFromDateObj(date);
  if (dateString) {
    setFromDateError("");
  }
};

const onChangeToDate = (date, dateString) => {
  setToDateString(dateString);
  setToDateObj(date);
  if (dateString) {
    setToDateError("");
  }
};


const getResponse = (inputData) => {
  console.log(inputData)

  makeRequest({
    type: APIConstants.GET,
    // GetFlowSteamGropeMeterDetails?GroupID=81
    url: `${APIConstants.ELECTRICAL_COMPARATIVE_REPORT}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`,
    // url: `${APIConstants.GET_STEAM_DASHBOARD_HISTORICAL_DETAILS}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}` 
  }).then((res) => {
 
    console.log(res)
    setData(res);
  });
}


const validateInput = (value, label) => {
  const error = !value ? `Please Select ${label}` : "";
  return error;
};


const validateToDateInput = (
  toDateValue,
  fromDateValue,
  aggregationPeriod,
  label
) => {
  switch (aggregationPeriod) {
    case 1: {
      // Validate if the time difference is a multiple of 15 minutes
      const timeDifferenceInMilliseconds =
        new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
      const timeDifferenceInMinutes =
        timeDifferenceInMilliseconds / (1000 * 60);

      const isMultipleOf15Minutes = timeDifferenceInMinutes % 15 === 0;
      const isAtLeast1Hour = timeDifferenceInMinutes >= 60;

      let error = "";
      if (!isMultipleOf15Minutes) {
        error = `Time difference must be a multiple of 15 minutes for ${label}`;
      } else if (!isAtLeast1Hour) {
        error = `Minimum time difference must be 1 hour for ${label}`;
      }

      return error;
    }
    case 2: {
      // Validate if the time difference is a multiple of 60 minutes
      const timeDifferenceInMilliseconds =
        new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
      const timeDifferenceInMinutes =
        timeDifferenceInMilliseconds / (1000 * 60);

      const isMultipleOf15Minutes = timeDifferenceInMinutes % 60 === 0;
      const isAtLeast1Hour = timeDifferenceInMinutes >= 8 * 60;

      let error = "";
      if (!isMultipleOf15Minutes) {
        error = `Time difference must be a multiple of 60 minutes for ${label}`;
      } else if (!isAtLeast1Hour) {
        error = `Minimum time difference must be 8 hours for ${label}`;
      }

      return error;
    }
    case 3: {
      // Validate if the time difference is a multiple of 60 minutes
      const timeDifferenceInMilliseconds =
        new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
      const timeDifferenceInMinutes =
        timeDifferenceInMilliseconds / (1000 * 60);

      const isMultipleOf15Minutes = timeDifferenceInMinutes % (60 * 24) === 0;
      const isAtLeast1Hour = timeDifferenceInMinutes >= 7 * 24 * 60;

      let error = "";
      if (!isMultipleOf15Minutes) {
        error = `Time difference must be a multiple of 24 hours for ${label}`;
      } else if (!isAtLeast1Hour) {
        error = `Minimum time difference must be 1 week for ${label}`;
      }

      return error;
    }
    case 4: {
      // Validate if the time difference is a multiple of 60 minutes
      const fromDate = new Date(fromDateValue);
      const toDate = new Date(toDateValue);

      const monthsDifference =
        (toDate.getUTCFullYear() - fromDate.getUTCFullYear()) * 12 +
        (toDate.getUTCMonth() - fromDate.getUTCMonth())
        // +toDate.getUTCDate()-fromDate.getUTCDate());
        
        
        //   // Calculate the year and month difference
       
        

      const isMultipleOf15Minutes = monthsDifference % 1 === 0; // Check if it's a whole number of months
      const isAtLeast6Months = monthsDifference >= 2; 
     

      let error = "";
      if (!isMultipleOf15Minutes) {
        error = `Time difference must be a multiple of 1 month for ${label}`;
      } else if (!isAtLeast6Months) {
        error = `Minimum time difference must be 2 month for ${label}`;
      }

      return error;
    }
    case 5: {
      // Validate if the time difference is a multiple of 60 minutes
      const timeDifferenceInMilliseconds =
        new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
      const timeDifferenceInMinutes =
        timeDifferenceInMilliseconds / (1000 * 60);

      const isMultipleOf15Minutes = timeDifferenceInMinutes % (60 * 8) === 0;
      const isAtLeast1Hour = timeDifferenceInMinutes >= 24 * 60;

      let error = "";
      if (!isMultipleOf15Minutes) {
        error = `Time difference must be a multiple of 8 hours for ${label}`;
      } else if (!isAtLeast1Hour) {
        error = `Minimum time difference must be 1 day for ${label}`;
      }

      return error;
    }
    default: {
      // Handle invalid aggregation period
      return `Invalid aggregation period: ${aggregationPeriod}`;
    }
  }
};



const handleSubmit = async () => {
const sectionError = validateInput(sectionId, "Section");
const converterError = validateInput(converterGroupId, "Converter");
const meterError = validateInput(selectedMeterIds?.length, "Meter");
const paraError = validateInput(selectedValues, "Parameter");
const fromDateError = validateInput(fromDateString, "From Date");
const toDateError = validateToDateInput(
  toDateString,
  fromDateString,
  aggregationTime,
  "From Date"
);
const aggregationError = validateInput(aggregationTime, "Aggregation");

setSectionError(sectionError);
setConverterError(converterError);
setMeterError(meterError);
// setParaError(paraError);
setFromDateError(fromDateError);
setToDateError(toDateError);
setAggregationError(aggregationError);

if (
  !sectionError &&
  !converterError &&
  !meterError &&
  !paraError &&
  !fromDateError &&
  !toDateError &&
  !aggregationError
) {
  onClose();

  const ids = selectedMeterIds?.map((id) => id).join(",");

  const fromDate = new Date(fromDateString);
  const toDate = new Date(toDateString);

  const fromHours = fromDate.getUTCHours();
  const fromMinutes = fromDate.getUTCMinutes();
  const fromSeconds = fromDate.getUTCSeconds();

  const toHours = toDate.getUTCHours();
  const toMinutes = toDate.getUTCMinutes();
  const toSeconds = toDate.getUTCSeconds();

  // Set the UTC hours, minutes, and seconds
  fromDate.setUTCHours(fromHours);
  fromDate.setUTCMinutes(fromMinutes);
  fromDate.setUTCSeconds(fromSeconds);

  toDate.setUTCHours(toHours);
  toDate.setUTCMinutes(toMinutes);
  toDate.setUTCSeconds(toSeconds);

  const formattedFromDate = generatedISOFormatDateString(fromDate);
  const formattedToDate = generatedISOFormatDateString(toDate);

  try {
    const inputData = {
      SectionID: Number(sectionId) || 1,
      ConverterorGroupID: Number(converterGroupId) || 40,
      MeterIds: ids || ["1"],
      FromDate: formattedFromDate || "2023-09-21T15:52:20.000Z",
      ToDate: formattedToDate || "2023-09-21T15:58:20.000Z",
    };

    setIsLoading(true); 
    getResponse(inputData)



    console.log('first data')
    console.log(data)
    console.log(aggeregationResData)

    const aggregationName = aggeregationResData.find(
      (aggregation) => aggregation.aggregationPeriodID === aggregationTime
    ).aggregationPeriodName;

    const period =
      aggregationName === "15Mins"
        ? "min"
        : aggregationName === "60Min Report"
          ? "min"
          : aggregationName === "24Hours Report"
            ? "day"
            : aggregationName === "Monthly Report"
              ? "month"
              : "min";

    const interval =
      aggregationName === "15Mins"
        ? 15
        : aggregationName === "60Min Report"
          ? 60
          : aggregationName === "24Hours Report"
            ? 1
            : aggregationName === "Monthly Report"
              ? 1
              : 480;

    const seriesData = groupDataByInterval(
      data,
      interval,
      period,
      fromDate
    );

    const input = seriesData?.chartArray;

    const inputArr = input;
    const dateArray = seriesData?.firstRecordCreatedONArray;
    console.log(dateArray)

    // update in columnData
    setChartData((prevChartData) => ({
      series: inputArr || [],
      options: {
        ...prevChartData.options,
        xaxis: {
          ...prevChartData.options.xaxis,
          categories: dateArray || [1,2],
        },
      },
    }));
  } catch (err) {
    console.log(err);
  }finally {
    setIsLoading(false); 
  }
}
};

const parameters = [
  { id: 1, name: "flowRate" },
  { id: 2, name: "cumulative" },
];
const handleTreeChange = (values) => {
  setSelectedValues(values);
  if (values) {
    setParaError("");
  }
};

return (
  <div>
   
   <div id="chart" className={` relative p-4 rounded-md  dark ${isdarkMode ? 'darkmode' : 'whitemode'} `}>
    {isLoading && (
      <div className="absolute inset-0 flex justify-center items-center bg-white dark:bg-gray-800 bg-opacity-50 dark:bg-opacity-50 z-10">
        <Spin active paragraph={{ rows: 6 }} />
      </div>
    )}


    <Card
      className={`p-4 rounded-md dark  ${isdarkMode ? "darkmode" : "whitemode"} 
w-full lg:w-full md:w-11/12 sm:w-10/12 xs:w-11/12`}
    >


      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={500}
        className="w-full"
 
      />


    </Card>
    </div>
    <CustomDrawer
      title="Close"
      showDrawer={showDrawer}
      open={open}
      onClose={onClose}
    >
      <div className="flex flex-col space-y-2">
        <CustomSelect
          label="Section:"
          options={getFlowSectionList}
          onSelect={handleChangeSection}
          valueKey="sectionID"
          nameKey="sectionName"
        />
        <small className="text-red-500 font-bold ml-[150px]">
          {/* {sectionError} */}
        </small>
        <CustomSelect
          label="Converter / Group:"
          options={
            sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
          }
          onSelect={handleChangeConverterGroup}
          valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
          nameKey={sectionId === 1 ? "sitename" : "groupName"}
        />
        <small className="text-red-500 font-bold ml-[150px]">
          {/* {converterError} */}
        </small>
        <TreeSelectCustomWithSelectAll
          label="Meters:"
          data={
            sectionId === 1
              ? nsGetFlowConverterList
              : getFlowSteamGroupMeterList
          }
          idKey={sectionId === 1 ? "meterid" : "MeterID"}
          valueKey={sectionId === 1 ? "meterid" : "meterID"}
          nameKey={sectionId === 1 ? "metername" : "meterName"}
          selectedValues={selectedMeterIds}
          setSelectedValues={setSelectedMeterIds}
          onSelect={handleMeterChange}
        />
        <small className="text-red-500 font-bold ml-[150px]">
          {/* {meterError} */}
        </small>
        <TreeSelectCustom 
          label="Parameters:"
          data={parameters}
          idKey="id"
          nameKey="name"
          valueKey="name"
          selectedValues={selectedValues}
          onSelect={handleTreeChange}
        />
        <small className="text-red-500 font-bold ml-[150px]">
          {/* {paraError} */}
        </small>
        <CustomSelect
          label="Aggregation period:"
          options={aggeregationList}
          onSelect={handleChangeAggregation}
          valueKey="aggregationPeriodID"
          nameKey="aggregationPeriodName"
        />
        <small className="text-red-500 font-bold ml-[150px]">
          {aggregationError}
        </small>
       
        <div className="mt-2 flex">
          <label className="pr-3 w-32 text-left">From Date:</label>
          <DatePicker
            value={fromDateObj}
            onChange={onChangeFromDate}
            className="w-80"
            showTime={{ format: "HH:mm:ss" }}
            format="YYYY-MM-DD HH:mm:ss"
          />
        </div>
        <small className="text-red-500 font-bold ml-[150px]">
          {/* {fromDateError} */}
        </small>
        <div className="mt-2 flex">
          <label className="pr-3 w-32 text-left">To Date:</label>
          <DatePicker
            value={toDateObj}
            onChange={onChangeToDate}
            className="w-80"
            showTime={{ format: "HH:mm:ss" }}
            format="YYYY-MM-DD HH:mm:ss"
          />
        </div>
        <small className="text-red-500 font-bold ml-[150px]">
          {toDateError}
        </small>
      </div>
      <div className="flex justify-center mt-4">
        <Button
          className="blue-btn"
          onClick={() => {
            handleSubmit();
          }}
        >
          Search
        </Button>
      </div>
    </CustomDrawer>
  </div>
);
};

export default ComparitiveReport;






